import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Policies.css';

const SafetyTips: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="policy-container">
      <button className="back-button" onClick={() => navigate(-1)}>
        ← Back
      </button>
      <h1>Safety Tips</h1>

      <section className="policy-section">
        <p>Your safety is our priority. Please follow these guidelines while using Fervoir.</p>

        <div className="policy-point">
          <h3>1. Protect Your Personal Information</h3>
          <ul>
            <li>Don't share your home address, workplace, phone number, or financial details.</li>
            <li>Keep conversations within the app until you trust the person.</li>
          </ul>
        </div>

        <div className="policy-point">
          <h3>2. Beware of Scammers</h3>
          <p><strong>Avoid:</strong></p>
          <ul>
            <li>Requests for money</li>
            <li>Suspicious links</li>
            <li>High-pressure or emotional stories</li>
          </ul>
          <p>Report such accounts immediately.</p>
        </div>

        <div className="policy-point">
          <h3>3. Meet in Public Places</h3>
          <p>When meeting someone for the first time:</p>
          <ul>
            <li>Choose a public place</li>
            <li>Tell a friend where you're going</li>
            <li>Arrange your own transport</li>
          </ul>
        </div>

        <div className="policy-point">
          <h3>4. Trust Your Instincts</h3>
          <p>If something feels wrong, stop the conversation or leave the situation.</p>
        </div>

        <div className="policy-point">
          <h3>5. Underage Use is Not Allowed</h3>
          <p>You must be 18+ to use Fervoir.</p>
        </div>
      </section>
    </div>
  );
};

export default SafetyTips;
